import React, {useState, useEffect} from 'react';
import { Grid, Box, } from "@mui/material";
import GeneralTable from "../../../../../create-report/shared-components/general-table/GeneralTable.js";
import { GENOME_COVERAGE } from "../config/genome_coverage.js";


export default function GenomeCoverage({data, report_id}) {

        //const token = useSelector(state => state.authorization.token);
    //     const [sectionData, setData] = useState(data)
    
    // useEffect(() => {
    //     if(report_id!== undefined && sectionData.length === data.length){
    //         setData(data)}
    // }, [report_id]);

    return (
        <Grid item xs={12}>
            <Box p={1}>
                <Box>
                <GeneralTable
                    dataType={"metrics"}
                    data={ data } columns={ GENOME_COVERAGE} />
                </Box>
            </Box>
        </Grid>
    );
}
